import isMobileDevice from '@assets/helpers/utils/isMobileDevice';

const DISPLAY_DEVICES = {
  ALL: 'all',
  DESKTOP: 'desktop',
  MOBILE: 'mobile'
};

export default function isCurrentDeviceAllowed(device) {
  if (device === DISPLAY_DEVICES.ALL) return true;

  return !(isMobileDevice()
    ? device === DISPLAY_DEVICES.DESKTOP
    : device === DISPLAY_DEVICES.MOBILE);
}
